import { FC } from 'react';
import {
  landingVideos,
  LANDING_VIDEO_THUMBNAIL,
} from '~/common/constants/video';

import styled from 'styled-components';

import useMediaQuery from '~/common/hooks/useMediaQuery';
import { useIsMounted } from '~/common/hooks/useIsMounted';
import { Image } from '~/components/wrappers/Image';
import { NavigationItem } from '~/layout/styles';
import { Routes } from '~/common/constants/routes';
import { useNavigation } from '~/common/hooks/useNavigation';
import { fontFamilies } from '~/theme/typography';

export const HomeHero: FC = () => {
  const { isMobile } = useMediaQuery();
  const { isMounted } = useIsMounted();
  const { goToShop } = useNavigation();

  return (
    <Section>
      <VideoThumbnail
        src={LANDING_VIDEO_THUMBNAIL}
        alt="Broken Planet streetwear collection featuring sustainable hoodies and clothing"
        loading="eager"
        fetchpriority="high"
        width={1920}
        height={1080}
      />

      {isMounted && (
        <BackgroundVideo loop autoPlay playsInline muted preload="metadata">
          <source
            src={isMobile ? landingVideos.mobile.mp4 : landingVideos.mp4}
            type="video/mp4"
          />
        </BackgroundVideo>
      )}
      <StyledNavigationItem
        to={Routes.Shop}
        onClick={goToShop}
        aria-label="Shop now"
      >
        <ShopNowText>SHOP HERE</ShopNowText>
      </StyledNavigationItem>
    </Section>
  );
};

const Section = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100svh;
  position: absolute;
  width: 100%;
  top: 0;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.black};
`;

const VideoThumbnail = styled(Image)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  filter: blur(4px);
  /* To make up for safari filter blur issue */
  transform: translate3d(0, 0, 0);
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  object-fit: cover;
`;

const ShopNowText = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: 2.5rem;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  transition: ${({ theme }) => `color ${theme.transitions.button}`};

  @media ${({ theme }) => theme.breakpoints.sm} {
    font-size: 2rem;
    letter-spacing: 0.16px;
  }
`;

const StyledNavigationItem = styled(NavigationItem)`
  z-index: ${({ theme }) => theme.zIndex.headingImage};
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
  padding: 0 16px;
  height: 80px;
  border-radius: 16px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: ${({ theme }) => `transform ${theme.transitions.button}`};

  &:hover {
    opacity: 0.7;
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    height: 64px;
  }
`;
